import { call, race, take } from "redux-saga/effects";
import { REDO_SEARCH } from "../actions/constants";

// A REDO_SEARCH means the search changed or a checkout visit began or ended, so a
// result still in flight (quote, main guest, earn, wallet offers) belongs to the
// previous checkout. Cancel it instead of letting it land in the next one — or,
// under takeLeading, swallow the next checkout's request.
export const cancelOnRedoSearch = <TAction>(
  saga: (action: TAction) => Generator
) =>
  function* (action: TAction) {
    yield race({
      completed: call(saga, action),
      redoSearch: take(REDO_SEARCH),
    });
  };
